import styled, { css } from 'styled-components';
import { BreakpointsSizes } from '../../@types/design-system/break-boints';
import Theme from '../../design-system/Theme';

const newTheme = new Theme();

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: #9B51E0;
  width: 100%;
`;
